import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { MembershipTypeDiscountDTOBase } from "./MembershipTypeDiscountDTOBase";
import type { MembershipTypeRef } from "./MembershipTypeRef";
import type { MembershipTypeStaff } from "./MembershipTypeStaff";
import type { TrackedBase } from "./TrackedBase";

export class MembershipTypeDiscountStaff implements MembershipTypeDiscountDTOBase, TrackedBase {
  constructor(public readonly discountId: number, public readonly membershipTypeId: MembershipTypeStaff | null, public readonly discountAmt: number | null, public readonly description: string | null, public readonly regCodeRowId: number | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly membershipTypeIdTargetIds: MembershipTypeRef | null) {
    this.cbiServiceContext = null;
    this.membershipTypeIdLoaded = this.membershipTypeId != null;
    this.membershipTypeIdCached = this.membershipTypeId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private membershipTypeIdLoaded: boolean;
  private membershipTypeIdCached: MembershipTypeStaff | null;
  async membershipTypeIdLazy(): Promise<MembershipTypeStaff | null> {
    if (!this.membershipTypeIdLoaded) {
      this.membershipTypeIdCached = await (this.membershipTypeIdTargetIds != null ? this.cbiServiceContext!.membershipService().getMembershipTypeStaff(this.membershipTypeIdTargetIds.membershipTypeId) : Promise.resolve(null));
      this.membershipTypeIdLoaded = true;
    }
    return this.membershipTypeIdCached;
  }
}
